/* BIA size guide: tabs, cm/inch conversion, focus handling.
   Category-aware: the tab matching the product's detected category opens by
   default, read from data-bsg-cat on the dialog. Without JS the dialog still
   opens via native <dialog> with the correct panel already visible and the
   other panels marked hidden, so the guide is never inaccessible and never
   shows the wrong category. */
(function () {
  var dlg, lastTrigger = null, inch = false;

  var CAT_TAB = { top: 't', shaping: 's', dress: 'd' };

  function defaultTab() {
    return (dlg && CAT_TAB[dlg.getAttribute('data-bsg-cat')]) || 'd';
  }

  function selectTab(key) {
    dlg.querySelectorAll('[data-bsg-tab]').forEach(function (b) {
      var on = b.getAttribute('data-bsg-tab') === key;
      b.setAttribute('aria-selected', String(on));
      b.tabIndex = on ? 0 : -1;
    });
    dlg.querySelectorAll('[data-bsg-panel]').forEach(function (p) {
      p.hidden = p.getAttribute('data-bsg-panel') !== key;
    });
  }

  /* Cells carry a Liquid-computed data-in, so ranges like "54–100" convert on
     both ends. Falls back to arithmetic only if data-in is absent. */
  function applyUnits() {
    dlg.querySelectorAll('[data-bsg-unit]').forEach(function (u) {
      u.textContent = inch ? 'in' : 'cm';
    });
    dlg.querySelectorAll('[data-cm]').forEach(function (td) {
      var cm = td.getAttribute('data-cm');
      if (!inch) { td.textContent = cm; return; }
      var pre = td.getAttribute('data-in');
      td.textContent = pre || cm.replace(/[0-9.]+/g, function (n) {
        return (parseFloat(n) * 0.393701).toFixed(1);
      });
    });
    dlg.querySelectorAll('[data-bsg-units]').forEach(function (b) {
      b.textContent = inch ? 'Show in centimetres' : 'Show in inches';
    });
  }

  function open(tab, trigger) {
    dlg = document.getElementById('bia-size-guide');
    if (!dlg) return;
    lastTrigger = trigger || null;
    selectTab(tab || defaultTab());
    applyUnits();
    if (dlg.showModal && !dlg.open) dlg.showModal(); else dlg.setAttribute('open', '');
    document.body.style.overflow = 'hidden';
    var t = dlg.querySelector('[aria-selected="true"]');
    if (t) t.focus();
  }

  function close() {
    if (!dlg) return;
    if (dlg.close && dlg.open) dlg.close(); else dlg.removeAttribute('open');
    document.body.style.overflow = '';
    if (lastTrigger && lastTrigger.focus) lastTrigger.focus();
  }

  document.addEventListener('click', function (e) {
    var openBtn = e.target.closest('[data-bp-guide-open],[data-bsg-open]');
    if (openBtn) {
      e.preventDefault();
      /* An explicit data-bsg-open value still wins; empty or absent means
         "use this product's category". */
      var want = openBtn.getAttribute('data-bsg-open');
      open(want || null, openBtn);
      return;
    }
    var tab = e.target.closest('[data-bsg-tab]');
    if (tab) { dlg = tab.closest('dialog'); selectTab(tab.getAttribute('data-bsg-tab')); return; }
    var unitBtn = e.target.closest('[data-bsg-units]');
    if (unitBtn) { dlg = unitBtn.closest('dialog'); inch = !inch; applyUnits(); return; }
    if (e.target.closest('[data-bsg-close]')) { close(); }
  });

  document.addEventListener('keydown', function (e) {
    var d = document.getElementById('bia-size-guide');
    if (!d || !d.open) return;
    if (e.key === 'Escape') { e.preventDefault(); dlg = d; close(); }
    if (e.key === 'ArrowRight' || e.key === 'ArrowLeft') {
      var tabs = Array.prototype.slice.call(d.querySelectorAll('[data-bsg-tab]'));
      var i = tabs.findIndex(function (t) { return t.getAttribute('aria-selected') === 'true'; });
      var n = (i + (e.key === 'ArrowRight' ? 1 : -1) + tabs.length) % tabs.length;
      dlg = d; selectTab(tabs[n].getAttribute('data-bsg-tab')); tabs[n].focus();
    }
  });
})();
